/* eslint-disable import/prefer-default-export */
export const ACTIONS_AFTER_RESET_SECRET = {
  LOGIN: 'login',
  RESET_PASSWORD: 'reset-password',
};

export const TOTP_STEPS_COUNT = 4;

export const securityTOTPScreens = {
  MAIN: 'main',
  SCAN: 'scan',
  SAVE: 'save',
  VERIFY: 'verify',
  RESET_WARNING: 'reset_warning',
  RESET_TFA: 'reset_tfa',
};
